import React, { useState, useEffect, useRef } from 'react';
import { addDetectUserEvents, removeDetectUserEvents, useDetectMobile } from '../utils';
import '../../../stylesheets/triagebot/OpenSummary.scss';
import '../../../stylesheets/triagebot/SummaryEmbeddedNps.scss';

import OpenRecommendCard from './OpenRecommendCard';
import OpenSummaryOptions from './OpenSummaryOptions';
import OvPossibleCauses from './OvPossibleCauses';
import NpsCard from './NpsCard';
import { getMarkDown } from '../utils';



const SummaryMessage = ({ message, sendMessage, setToastMessage, disabled, HoverColor, setSuppressSummary, setPrintData }) => {

    const [submitted, setSubmitted] = useState(false);
    //const [selectedCareOption, setSelectedCareOption] = useState('');
    const [selectedSelf911ERCard, setselectedSelf911ERCard] = useState(false);

    var timer = null;

    const { isMobile } = useDetectMobile();

    const isDisabled = submitted || disabled;
    const open911Text = message?.data?.[2]?.summaryCardContent?.open911Text
        ? message.data[2].summaryCardContent.open911Text
        : '';
        
    const triageLevel = message?.data?.[0]?.triageMapping?.triagelevel
        ? message.data[0].triageMapping.triagelevel.toLowerCase()
        : 'unknown';
    const showPossibleCauses = triageLevel !== 'emergency' && triageLevel !== 'emergency_ambulance';

    // Extract recommendation header and body from backend (for "open" CDO)
    const openCareRecommendationHeader = message?.data?.[2]?.summaryCardContent?.openCareRecommendationHeader
        ? message.data[2].summaryCardContent?.openCareRecommendationHeader
        : 'Mock Title/header';

    const openCareRecommendationBody = message?.data?.[2]?.summaryCardContent?.openCareRecommendationBody
        ? message.data[2].summaryCardContent?.openCareRecommendationBody
        : 'Mock Description';

    const openSummaryBottomText = message?.data?.[2]?.summaryCardContent?.openSummaryBottomText
        ? message.data[2].summaryCardContent.openSummaryBottomText
        : '';

    const handleTimerOut = () => {
        //        sendMessage('message', 'NPS Timeout', 'NPS Timeout');
        removeDetectUserEvents(resetTimer);
    }

    const resetTimer = () => {
        timer && clearTimeout(timer);

        timer = setTimeout(handleTimerOut, 5000);
    }


    useEffect(() => {
        resetTimer();
        addDetectUserEvents(resetTimer);

        setSuppressSummary(true);

        return () => {
            clearTimeout(timer);
            removeDetectUserEvents(resetTimer);
        }
    }, [])

  
    const messageRef = useRef();

    useEffect(() => {
        if (messageRef.current) {
            messageRef.current.scrollIntoView(
                {
                    behavior: 'smooth',
                    block: 'start'
                })
        }
    }, []);

    // Determine which recommendation card to render based on triage level for Open Version CDO
    const renderRecommendCard = () => {
        // For "open" CDO, use triageLevel to determine the card type
        const careType = triageLevel;

        // Use backend data for title and text
        const triageTitle = openCareRecommendationHeader;
        const triageTextContent = openCareRecommendationBody;

        const concerningSymptoms = (message?.data?.[3]?.serious || [])
            .map(symptom => symptom.common_name);
        const concerningSymptomsHeader = message?.data?.[2]?.summaryCardContent?.openConcerningSymptomsHeader
            ? message.data[2].summaryCardContent.openConcerningSymptomsHeader
            : 'Concerning symptoms:';

        // Render individual recommendation cards based on care type
        switch (careType) {
            case 'self_care':
                return <OpenRecommendCard variant='selfcare' message={message} triageTitle={triageTitle} triageText={triageTextContent} useMarkdown />;
            
            case 'primary_care':
            case 'consultation':
            case 'consultation24':
            case 'virtual_care':
                return <OpenRecommendCard variant='appointment' message={message} triageTitle={triageTitle} triageText={triageTextContent} />;
            
            case 'urgent_care':
                return <OpenRecommendCard variant='urgentcare' message={message} triageTitle={triageTitle} triageText={triageTextContent} />;
            
            case 'emergency_ambulance':
            case 'emergency':
                return (
                    <OpenRecommendCard
                        variant='emergency'
                        message={message}
                        triageTitle={triageTitle}
                        triageText={triageTextContent}
                        concerningSymptoms={concerningSymptoms}
                        concerningSymptomsHeader={concerningSymptomsHeader}
                    />
                );
            
            default:
                // Fallback to self-care card for unknown triage levels
                return <OpenRecommendCard variant='selfcare' message={message} triageTitle={triageTitle} triageText={triageTextContent} useMarkdown />;
        }
    };

    return (
        <div className='summary-card' ref={messageRef}>
            <div className='summary_header'>
                {open911Text}
            </div>
            <div className='care-recommendation'>
                {renderRecommendCard()}
            </div>
            {showPossibleCauses && (
                <div className='possible-cause'>
                    <OvPossibleCauses message={message} sendMessage={sendMessage} setToastMessage={setToastMessage} disabled={isDisabled} />
                </div>
            )}
            <div className='summary-options'>
                <OpenSummaryOptions 
                    message={message} 
                    sendMessage={sendMessage} 
                    disabled={isDisabled} 
                    setSubmitted={submitted => setSubmitted(submitted)}
                    setToastMessage={setToastMessage}
                    setselectedSelf911ERCard={setselectedSelf911ERCard}
                />
            </div>

            {/* Conditionally render NPS card inside summary for Open CDO when selfcare or emergency selected */}
            {selectedSelf911ERCard  && (
                <div className='summary-embedded-nps'>
                    <NpsCard 
                        message={message} 
                        sendMessage={sendMessage} 
                        disabled={disabled} 
                        selfCare911ERSelected={selectedSelf911ERCard}
                        onFeedbackSubmit={() => setSubmitted(true)}
                    />
                </div>
            )}

              <div className='summary-content'>
            {getMarkDown(openSummaryBottomText)}  
            </div>

        </div >);
}

export default SummaryMessage;